import "./_Features.scss";

const Features = ({ features }) => {
  return (
    <div className="features__container">
      <h6>features</h6>
      <p>{features}</p>
    </div>
  );
};

export default Features;
